import {
  getBreadCrumbList,
  setTagNavListInLocalstorage,
  getMenuByRouter,
  getTagNavListFromLocalstorage,
  getHomeRoute,
  getNextRoute,
  routeHasExist,
  routeEqual,
  getRouteTitleHandled,
  localSave,
  localRead
} from '@/libs/util'
import { saveErrorLogger, getDataSummary, getUserDuaTrend, getDailyTrend, getDayRegionVisit, getLotteryTypeStatistics, getUserVisits, getUserBetInfo, getSourceVisitsStat, getPlatformVisitsStat } from '@/api/data'
import router, { routes1 } from '@/router'
// import routers from '@/router/routers'
import config from '@/config'
import { mainList } from '@/api/routers'

const { homeName } = config

const closePage = (state, route) => {
  const nextRoute = getNextRoute(state.tagNavList, route)
  state.tagNavList = state.tagNavList.filter(item => {
    return !routeEqual(item, route)
  })
  router.push(nextRoute)
}

export default {
  state: {
    breadCrumbList: [],
    tagNavList: [],
    homeRoute: {},
    local: localRead('local'),
    errorList: [],
    hasReadErrorPage: false,
    menuRspList: [],
    routes: [],
    addRoutes: []
  },
  getters: {
    // menuList: (state, getters, rootState) => getMenuByRouter(routers, rootState.user.access),
    menuList: (state, getters, rootState) => getMenuByRouter(state.menuRspList, rootState.user.access),
    errorCount: state => state.errorList.length,
    menuRspList: (state, getters, rootState) => getMenuByRouter(state.menuRspList, rootState.user.access),
    routes: state => state.routes,
    routesList: state => state.addRoutes
  },
  mutations: {
    setBreadCrumb (state, route) {
      state.breadCrumbList = getBreadCrumbList(route, state.homeRoute)
    },
    setHomeRoute (state, routes) {
      state.homeRoute = getHomeRoute(routes.options.routes, homeName)
    },
    setTagNavList (state, list) {
      let tagList = []
      if (list) {
        tagList = [...list]
      } else tagList = getTagNavListFromLocalstorage() || []
      if (tagList[0] && tagList[0].name !== homeName) tagList.shift()
      let homeTagIndex = tagList.findIndex(item => item.name === homeName)
      if (homeTagIndex > 0) {
        let homeTag = tagList.splice(homeTagIndex, 1)[0]
        tagList.unshift(homeTag)
      }
      state.tagNavList = tagList
      setTagNavListInLocalstorage([...tagList])
    },
    closeTag (state, route) {
      let tag = state.tagNavList.filter(item => routeEqual(item, route))
      route = tag[0] ? tag[0] : null
      if (!route) return
      closePage(state, route)
    },
    addTag (state, { route, type = 'unshift' }) {
      let router = getRouteTitleHandled(route)
      if (!routeHasExist(state.tagNavList, router)) {
        if (type === 'push') state.tagNavList.push(router)
        else {
          if (router.name === homeName) state.tagNavList.unshift(router)
          else state.tagNavList.splice(1, 0, router)
        }
        setTagNavListInLocalstorage([...state.tagNavList])
      }
    },
    setLocal (state, lang) {
      localSave('local', lang)
      state.local = lang
    },
    addError (state, error) {
      state.errorList.push(error)
    },
    setHasReadErrorLoggerStatus (state, status = true) {
      state.hasReadErrorPage = status
    },
    setMenuRspList (state, list) {
      state.menuRspList = list
    },
    SET_ROUTES: (state, routes) => {
      state.addRoutes = routes
      state.routes = routes1.concat(routes)
    }
  },
  actions: {
    addErrorLog ({ commit, rootState }, info) {
      if (!window.location.href.includes('error_logger_page')) commit('setHasReadErrorLoggerStatus', false)
      const { user: { token, userId, userName } } = rootState
      let data = {
        ...info,
        time: Date.parse(new Date()),
        token,
        userId,
        userName
      }
      saveErrorLogger(info).then(() => {
        commit('addError', data)
      })
    },
    getMenuData ({ commit, rootState }, params) {
      return new Promise(resolve => {
        mainList().then(res => {
          const data = res.data.result
          let list = []
          if (data) {
            list = getMenuByRouter(data[0].children, rootState.user.access)
            commit('SET_ROUTES', list)
            commit('setMenuRspList', data[0].children)
          }
          resolve(list)
        }).catch(e => {
          commit('setToken', '')
        })
      })
    },
    getDataSummary ({ commit, rootState }, params) {
      return new Promise(resolve => {
        getDataSummary().then(res => {
          resolve(res)
        }).catch(e => {
        })
      })
    },
    getUserDuaTrend ({ commit, rootState }, params) {
      return new Promise(resolve => {
        getUserDuaTrend(params).then(res => {
          resolve(res)
        }).catch(e => {
        })
      })
    },
    getDailyTrend ({ commit, rootState }, params) {
      return new Promise(resolve => {
        getDailyTrend(params).then(res => {
          resolve(res)
        }).catch(e => {
        })
      })
    },
    getDayRegionVisit ({ commit, rootState }, params) {
      return new Promise(resolve => {
        getDayRegionVisit(params).then(res => {
          resolve(res)
        }).catch(e => {
        })
      })
    },
    getLotteryTypeStatistics ({ commit, rootState }, params) {
      return new Promise(resolve => {
        getLotteryTypeStatistics(params).then(res => {
          resolve(res)
        }).catch(e => {
        })
      })
    },
    getUserVisits ({ commit, rootState }, params) {
      return new Promise(resolve => {
        getUserVisits(params).then(res => {
          resolve(res)
        }).catch(e => {
        })
      })
    },
    getUserBetInfo ({ commit, rootState }, params) {
      return new Promise(resolve => {
        getUserBetInfo(params).then(res => {
          resolve(res)
        }).catch(e => {
        })
      })
    },
    getSourceVisitsStat ({ commit, rootState }, params) {
      return new Promise(resolve => {
        getSourceVisitsStat(params).then(res => {
          resolve(res)
        }).catch(e => {
        })
      })
    },
    getPlatformVisitsStat ({ commit, rootState }, params) {
      return new Promise(resolve => {
        getPlatformVisitsStat(params).then(res => {
          resolve(res)
        }).catch(e => {
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/app.js